"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mkEntityIdCodec = exports.genHexId = exports.genEntityId = exports.isEntityId = void 0;
exports.fromLiteral = fromLiteral;
const non_secure_1 = require("nanoid/non-secure");
const prelude_1 = require("../prelude");
const ID_CHARS = '23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz';
const EntityIdRegExp = new RegExp(`^[${ID_CHARS}]{17}$`);
const isEntityId = (u) => prelude_1.string.isString(u) && EntityIdRegExp.test(u);
exports.isEntityId = isEntityId;
const genEntityId = () => (0, non_secure_1.customAlphabet)(ID_CHARS)(17);
exports.genEntityId = genEntityId;
const genHexId = () => (0, non_secure_1.nanoid)(50);
exports.genHexId = genHexId;
/**
 * Creates a branded EntityId codec that respects Meteor's rules for Mongo document IDs and
 * produces nominal ID types that can't be accidentally mixed up with each other.
 */
const mkEntityIdCodec = (sym) => {
    const is = (u) => (0, exports.isEntityId)(u);
    return new prelude_1.iots.Type(sym.description ?? sym.toString(), is, (u, c) => (is(u) ? prelude_1.iots.success(u) : prelude_1.iots.failure(u, c)), String);
};
exports.mkEntityIdCodec = mkEntityIdCodec;
/**
 * Creates an EntityId from a literal using a type assertion.
 * Caution: The input is not validated; use this function only when it is guaranteed that the
 * input represents a valid value.
 */
function fromLiteral(literal) {
    return literal;
}
//# sourceMappingURL=identity.js.map